// 띠(strip) 지오메트리 배치: seg칸을 정점 쌍(안쪽 v=0, 바깥쪽 v=1)으로 이은 사각 띠 strips장.
// 한 슬롯 정점 수 = strips × (seg+1) × 2, 정점 순서 = [띠0: 쌍0 안, 쌍0 밖, 쌍1 안, …][띠1: …]
import type { BatchLayout } from './batch';

export function stripLayout(seg: number, strips = 1): BatchLayout {
  const per = (seg + 1) * 2;
  const uv: number[] = [];
  const indices: number[] = [];
  for (let s = 0; s < strips; s++) {
    for (let i = 0; i <= seg; i++) {
      uv.push(i / seg, 0, i / seg, 1);
    }
    for (let i = 0; i < seg; i++) {
      const a = s * per + i * 2, b = a + 1, c = a + 2, d = a + 3;
      indices.push(a, c, b, b, c, d);
    }
  }
  return { verts: per * strips, indices, uv };
}

/** 사각형 한 장(정점 4: 근-좌, 근-우, 원-좌, 원-우) */
export function quadLayout(): BatchLayout {
  return { verts: 4, indices: [0, 2, 1, 1, 2, 3], uv: [0, 0, 1, 0, 0, 1, 1, 1] };
}

/**
 * 원통 격자: 둘레 cols칸(정점 cols+1줄) × 높이 방향 줄 vs.length개. u = 둘레 0..1, v = vs[j].
 * 정점 순서 = [줄0: 둘레 0..cols][줄1: …]. 기둥(옆면+바닥 퍼짐)과 오라가 쓴다.
 */
export function gridLayout(cols: number, vs: readonly number[]): BatchLayout {
  const rows = vs.length;
  const uv: number[] = [];
  const indices: number[] = [];
  for (let j = 0; j < rows; j++) for (let i = 0; i <= cols; i++) uv.push(i / cols, vs[j]);
  const w = cols + 1;
  for (let j = 0; j < rows - 1; j++) {
    for (let i = 0; i < cols; i++) {
      const a = j * w + i, b = a + 1, c = a + w, d = c + 1;
      indices.push(a, c, b, b, c, d);
    }
  }
  return { verts: w * rows, indices, uv };
}
